import { UserAccessRightsGuard } from './../role/user-role/user-access-rights.guard'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { OrganizationCreateComponent } from './create/show.component'
import { OrganizationGeneralTabComponent } from './general-tab/show.component'
import { OrganizationIndexComponent } from './index/index.component'
import { OrganizationShowComponent } from './show/show.component'
import { OrganizationUserRolesTabComponent } from './user-roles-tab/show.component'
import { OrganizationSaleTabComponent } from './sale-tab/show.component'
import { OrganizationRequiredSubscriptionTabComponent } from './required-subscription-tab/show.component'
import { OrganizationDocumentsTabComponent } from './documents-tab/show.component'
import { OrganizationActivitiesTabComponent } from './activities-tab/show.component'
import { OrganizationAddressesTabComponent } from './addresses-tab/show.component'
import { AccessRights } from '../role/user-role/user-role'
import { OrganizationBookingTabComponent } from './booking-tab/booking-tab.component'

const routes: Routes = [
  {
    path: '',
    component: OrganizationIndexComponent,
    pathMatch: 'full',
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Organizations_read] }
  },
  {
    path: 'create',
    component: OrganizationCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Organizations_write] }
  },
  {
    path: ':organizationId',
    component: OrganizationShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Organizations_read] },
    children: [
      {
        path: '',
        component: OrganizationGeneralTabComponent,
        pathMatch: 'full'
      },
      {
        path: 'user-roles',
        component: OrganizationUserRolesTabComponent
      },
      {
        path: 'sales',
        component: OrganizationSaleTabComponent
      },
      {
        path: 'required-subscriptions',
        component: OrganizationRequiredSubscriptionTabComponent
      },
      { path: 'documents', component: OrganizationDocumentsTabComponent },
      { path: 'activities', component: OrganizationActivitiesTabComponent },
      { path: 'addresses', component: OrganizationAddressesTabComponent },
      {
        path: 'bookings-organization',
        component: OrganizationBookingTabComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrganizationRoutingModule {}
